// extracted by mini-css-extract-plugin
export var searchHeader = "_9n-0";
export var searchHeaderDark = "_9n-1";